class LoginController {
    constructor($state, $stateParams, authService, myBookingService, languageService, cacheService) {
        'ngInject';

        this.reference = $stateParams.reference;
        this.surname = $stateParams.surname;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.authService = authService;
        this.myBookingService = myBookingService;
        this.languageService = languageService;
        this.cacheService = cacheService;
        this.errorMessage = '';
    }
    login() {
        this.errorMessage = '';

        if (!this.reference && !this.surname) {
            this.errorMessage = 'Please fill in your On The Beach booking reference and surname.';
            return;
        }
        if (!this.reference) {
            this.errorMessage = 'Please fill in your On The Beach booking reference.';
            return;
        }
        if (!this.surname) {
            this.errorMessage = 'Please fill in your surname.';
            return;
        }

        this.authService.loginByAgencyBookingReferenceAndCustomerSurname(this.reference, this.surname)
            .then(() => {
                return this.myBookingService.getGlobalInfoBooking(this.reference, true).then(bookingResponse => {
                    this.cacheService.set('customer', bookingResponse.customer);
                    this.cacheService.set('agencyBookingReference', this.reference);
                    this.cacheService.set('bookingReference', bookingResponse.booking.reference);
                    this.cacheService.set('onTheBeachBooking', true);

                    return this.$state.go('onTheBeach.booking.view', {
                        locale: this.$stateParams.locale
                    });
                });
            })
            .catch(() => {
                this.errorMessage = 'No booking found with the provided information. Please review the Booking reference and Surname informed.';
                this.authService.logout();
            });
    }
}

export default LoginController;



// WEBPACK FOOTER //
// ./client/app/routes/onTheBeach/login/login.controller.js